import { useEffect, useRef, useState } from 'react'

const useModals = ({ allOffers, itemId, auctionItem }: any) => {
  const [showBidModal, setShowBidModal] = useState<any>(false)
  const [showBanModal, setShowBanModal] = useState<any>(false)
  const [showBinMaoModal, setShowBinMaoModal] = useState<any>(false)
  const [showViewModal, setShowViewModal] = useState<any>(false)
  const [showViewPalletLotModal, setShowViewPalletLotModal] =
    useState<any>(false)
  const [negativeZBid, setNegativeZBid] = useState<any>(true)
  const [negativeZBan, setNegativeZBan] = useState<any>(true)
  const [negativeZBinMao, setNegativeZBinMao] = useState<any>(true)
  const [negativeZView, setNegativeZView] = useState<any>(true)
  const [modalAction, setModalAction] = useState<any>(null)
  const [modalData, setModalData] = useState<any>({})
  const [modalType, setModalType] = useState<any>()
  const [bins, setBins] = useState<any>([])
  const [binMade, setBinMade] = useState<any>(false)
  const [offerMade, setOfferMade] = useState<any>(false)
  const [offers, setOffers] = useState<any>([allOffers])
  const [showViewBtn, setShowViewBtn] = useState<any>(false)
  const [incrementModalVisible, setIncrementModalVisible] = useState(false)
  const descriptionRef = useRef<any>(null)
  const titleRef = useRef<any>(null)
  const imagesRef = useRef<any>(null)

  const hideModal = (type: any) => {
    let timeoutFunc: any = null
    if (type === 'Bid') {
      setShowBidModal(false)
      timeoutFunc = () => setNegativeZBid(true)
    }
    if (type === 'Ban') {
      setShowBanModal(false)
      timeoutFunc = () => setNegativeZBan(true)
    }
    if (type === 'View') {
      setShowViewModal(false)
      timeoutFunc = () => setNegativeZView(true)
    }
    if (type === 'ViewPalletLot') {
      setShowViewPalletLotModal(false)
      timeoutFunc = () => setNegativeZView(true)
    }
    if (type === 'BinMao') {
      setShowBinMaoModal(false)
      timeoutFunc = () => setNegativeZBinMao(true)
    }
    setTimeout(timeoutFunc, 200)
  }

  const toggleModal = (show: any, type: any) => {
    if (show) {
      if (type === 'Bid') {
        setShowBidModal(true)
        setNegativeZBid(false)
      }
      if (type === 'Ban') {
        setShowBanModal(true)
        setNegativeZBan(false)
      }
      if (type === 'View') {
        setShowViewModal(true)
        setNegativeZView(false)
      }
      if (type === 'ViewPalletLot') {
        setShowViewPalletLotModal(true)
        setNegativeZView(false)
      }
      if (type === 'BinMao') {
        setShowBinMaoModal(true)
        setNegativeZBinMao(false)
      }
    } else {
      hideModal(type)
    }
  }

  const handleBtnClick = (type: any) => {
    setModalType(type)
    toggleModal(true, 'BinMao')
  }

  useEffect(() => {
    if (itemId) {
      if (allOffers) {
        setOfferMade(allOffers.includes(itemId))
      }
      console.log('auctionItem item is.. ', auctionItem)
      if (
        auctionItem.containerLineItemList &&
        auctionItem.containerLineItemList.length
      ) {
        setShowViewBtn(true)
      }
    }
  }, [itemId, auctionItem])

  useEffect(() => {
    if (offers) {
      setOfferMade(offers.includes(itemId))
    }
  }, [offers]) // eslint-disable-line

  useEffect(() => {
    if (bins) {
      setBinMade(bins.includes(itemId))
    }
  }, [bins])

  return {
    state: {
      showBidModal,
      showBanModal,
      showBinMaoModal,
      showViewModal,
      showViewPalletLotModal,
      negativeZBid,
      negativeZBan,
      negativeZBinMao,
      negativeZView,
      modalAction,
      modalData,
      modalType,
      bins,
      binMade,
      offerMade,
      offers,
      showViewBtn,
      incrementModalVisible,
    },
    handlers: {
      setShowBidModal,
      setShowBanModal,
      setShowBinMaoModal,
      setShowViewModal,
      setShowViewPalletLotModal,
      setNegativeZBid,
      setNegativeZBan,
      setNegativeZBinMao,
      setNegativeZView,
      setModalAction,
      setModalData,
      setModalType,
      setBins,
      setBinMade,
      setOfferMade,
      setOffers,
      setShowViewBtn,
      hideModal,
      toggleModal,
      handleBtnClick,
      setIncrementModalVisible,
    },
    refs: { descriptionRef, titleRef, imagesRef },
  }
}

export default useModals
